export default {
      id: "sli-case-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cf73de4e.svg#sli-case",
      toString: function () {
        return this.url;
      }
    }